module.exports = { "default": require("core-js/library/fn/math/acosh"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/math/acosh.js
// module id = 1395
// module chunks = 2